import request from '@/utils/request'

// 检测用户名邮箱
export function checkUserNameOrPhone(params) {
    return request({
        url: '/swx/customer/login/checkUserNameOrPhone',
        method: 'get',
        params: {
            ...params
        }
    })
}

// 注册
export function register(data) {
    return request({
        url: '/swx/customer/login/register',
        method: 'post',
        data
    })
}

// 登录
export function login(data) {
    return request({
        url: '/swx/customer/login/login',
        method: 'post',
        data
    })
}

// 钱包登录
export function loginByWallet(data) {
    return request({
        url: '/swx/customer/login/loginByWallet',
        method: 'post',
        data
    })
}

// 查询是否启用邮件验证
export function emailVerifyEnabled() {
    return request({
        url: '/swx/customer/login/emailVerifyEnabled',
        method: 'get'
    })
}

// sendCode
export function sendCode(data) {
    return request({
        url: `/swx/customer/login/sendCode`,
        method: 'post',
        data
    })
}
// loginByGoogle
export function loginByGoogle(data) {
    return request({
        url: `/swx/customer/login/loginByGoogle`,
        method: 'post',
        data
    })
}









// 管理员以用户身份自动登录（一次性凭证交换）
export function adminAutoLogin(key) {
    return request({
        url: '/swx/customer/login/autoLogin',
        method: 'get',
        params: { key }
    })
}

// exmaple  qs

// import qs from 'qs';
// export function memberintegralflowList(data = {}) {
//   return request({
//     url: '/user/member-integral-flow-do/search?' + qs.stringify(data),
//     method: 'get'
//   });
// }